import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

const ParamSchema = Yup.object().shape({});

const pfFormInit = {
  Id: 0, PFDate: "", Rate: "", EmployerRate: "", PensionRate: "",
  MaxPensionAmt: "", MaxWagesForPF: "", MaxWagesForPension: "",
  AdminCharges: "", AdminChargesMinAmount: "",
  AC21WithGroupIns: "", AC21WithGroupInsMinAmt: "",
  AC22WithGroupIns: "", AC22WithGroupInsMinAmt: "",
  AC21WithoutGroupIns: "", AC22WithoutGroupIns: "",
  HigherPensionRate: "", PFBasis: false, PensionOnArrear: false,
  AC21Individually: false, NewLabourCodeApplyDate: "", NewLabourCodeBasicPrec: "",
};

const esiFormInit = {
  Id: 0, ESIDate: "", EmployeeContribution: "", EmployerContribution: "",
  WagesLimit: "", RoundedOn: false, EmployerPartIndividually: false,
  EmployeeExemptionLimit: "", Rural: false,
  NewLabourCodeApplyDate: "", NewLabourCodeBasicPrec: "",
};

const bonusFormInit = {
  Id: 0, BonusDate: "", BonusRate: "", MaximumWages: "", 
  MaximumWagesLimit: "", MaximumBonus: "", MinimumBonus: "", MinimumBonusDays: "",
};

const gratuityFormInit = {
  Id: 0, GratuityDate: "", Rate: "",
};

const CB = ({ label, name, value, onChange, col = "col-md-4" }) => (
  <div className={`${col} mb-2 d-flex align-items-center`}>
    <div className="form-check me-2">
      <input
        type="checkbox"
        className="form-check-input"
        id={name}
        name={name}
        checked={!!value}
        onChange={onChange}
      />
    </div>
    <label className="form-check-label mb-0" htmlFor={name} style={{ fontSize: 13, cursor: "pointer" }}>
      {label}
    </label>
  </div>
);

const AddEdit_PayrollParameter = () => {
  const [activeTab, setActiveTab] = useState("basicInfo");
  const [pfModalOpen, setPfModalOpen] = useState(false);
  const [pfForm, setPfForm] = useState(pfFormInit);
  const [pfRecords, setPfRecords] = useState([]);
  const [pfIndex, setPfIndex] = useState(0);
  const [pfEditMode, setPfEditMode] = useState(true);
  const setPF = (k, v) => setPfForm(p => ({ ...p, [k]: v }));

  const [esiModalOpen, setEsiModalOpen] = useState(false);
  const [esiForm, setEsiForm] = useState(esiFormInit);
  const [esiRecords, setEsiRecords] = useState([]);
  const [esiIndex, setEsiIndex] = useState(0);
  const [esiEditMode, setEsiEditMode] = useState(true);
  const setESI = (k, v) => setEsiForm(p => ({ ...p, [k]: v }));

  const [bonusModalOpen, setBonusModalOpen] = useState(false);
  const [bonusForm, setBonusForm] = useState(bonusFormInit);
  const [bonusRecords, setBonusRecords] = useState([]);
  const [bonusIndex, setBonusIndex] = useState(0);
  const [bonusEditMode, setBonusEditMode] = useState(true);
  const setBonus = (k, v) => setBonusForm(p => ({ ...p, [k]: v }));

  const [gratuityModalOpen, setGratuityModalOpen] = useState(false);
  const [gratuityForm, setGratuityForm] = useState(gratuityFormInit);
  const [gratuityRecords, setGratuityRecords] = useState([]);
  const [gratuityIndex, setGratuityIndex] = useState(0);
  const [gratuityEditMode, setGratuityEditMode] = useState(true);
  const setGratuity = (k, v) => setGratuityForm(p => ({ ...p, [k]: v }));

  const [state, setState] = useState({
    id: 0,
    PFData: [],
    formData: {
      // ── Basic Information ──
      EmployerName: "",
      Address: "",
      Designation: "",
      Bank: "",
      CreatePayrollAutomatically: false,
      PayrollOrderBy: "",
      DepartmentWisePayroll: false,
      RetirementAge: "",
      MinWages: "",
      ESIOnOT: false,
      PFOnOT: false,
      SundayInclude: false,
      SundayIncludeDeptwise: false,
      HourlyPayment: false,
      WagesRoundedOff: false,
      ArrearApplicable: false,
      PFOnArrear: false,
      ESIOnArrear: false,
      AllowancesOnArrear: false,
      DirectWagesEntry: false,
      DirectWagesDepartmentwise: false,
      NetPayableRoundedOff: false,
      CopyDaysToNextEmployee: false,
      MonthDayWithWHInBonus: false,
      LeaveWagesAmountOnBasicSalary: false,
      DisplayLeaveWagesPayment: false,
      OpLeaveWWagesInPayrollT: false,
      LeaveWithWagesDepartmentwise: false,
      GratuityEligibilityMonths: "",
      GratuityPayableDaysInMonth: "",
      ShowCompanyNameInDepartment: false,
      MultiESICode: false,
      MultiPF: false,
      MultiFactoryFirm: false,
      AllowanceDeductionEditable: false,
      AddOvertimeAmountInNetPayable: false,
      DontShowNCPInForm10C: false,
      CheckDuplicatePFNoEntry: false,
      CheckDuplicateESINoEntry: false,
      ShowForm3AWith0: false,
      NoWeeklyHolidayForDailyWages: false,
      NoDataOfContractor: false,
      NoPensionDataInWagesRegister: false,
      BasicEditable: false,
      CRLOnMonthDays: false,
      FirmHoliday: "",
      PFESIDuePaidDepartmentwise: false,
      AskToUpdatePaid: false,
      PieceWiseCalculation: false,
      // ── Other Information ──
      ESIEnabled: false,
      PFEnabled: false,
      GratuityRates: false,
      CRLDays: false,
      OverTime: false,
      Recovery: false,
      Advance: false,
      TDS: false,
      AdvanceBonus: false,
      PFAdvRefund: false,
      PFSection: "",
      MaxLwW: "",
      LwWUsage: "",
      MultiDepartmentSelection: false,
      Days26Working: false,
      Days26WorkingEmployeeWise: false,
      AddAbsentInPFChallan: false,
      BonusOnWorkingDays: false,
      MonthDayWOSundayForDailyWages: false,
      AC2122OnFixedMaxPFWages: false,
      DepartmentInWagesRegisterOrderWise: false,
      OverLimitESICalcOnESILimit: false,
      FullESIByEmployer: false,
      TransactionLocked: false,
      OvertimeOnGrossWages: false,
      EntryFromExternal: false,
      DoubleOvertimeAmount: false,
      BonusOnMinWages: false,
      MinWagesEditable: false,
      FullPFByEmployer: false,
      MaxWHValidate: false,
      OvertimeOn26Days: false,
      ExtraPay: false,
      PFOnExtraPay: false,
      ESIOnExtraPay: false,
      ExtraPayCaption: "",
      ExtraPay1: false,
      PFOnExtraPay1: false,
      ESIOnExtraPay1: false,
      ExtraPayCaption1: "",
      BonusMonthlyInPayroll: false,
      // ── Allow Deduction ──
      FactoryActAddressDetails: "",
      PFAddressDetails: "",
      ESIAddressDetails: "",
    },
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_GET = API_WEB_URLS.MASTER + '/0/token/PayrollParameter/TBL.F_FirmMaster/';
  const API_URL_SAVE = "PayrollParameter/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/PayrollParameterEdit/Id`;

useEffect(() => {
  const fetchData = async () => {
    const Id = (location.state && location.state.Id) || 0;

    const firmData = JSON.parse(localStorage.getItem("selectedFirm") || "{}");
    const firmId = firmData.Id || 0;

    // ✅ GET list data
   const res= await Fn_FillListData(
      dispatch,
      () => {},
      "Data",
      `${API_URL_GET}${firmId}`
    );
console.log("Fetched PayrollParameter data:", res);

    // ✅ If data array exists and has records, populate form
    if (res && Array.isArray(res) && res.length > 0) {
      const data = res[0]; // Use first record
      
      // Determine PayrollOrderBy based on boolean flags
      let payrollOrderBy = "";
      if (data.IsPFNoWise) payrollOrderBy = "PFNoWise";
      else if (data.IsSerialNoWise) payrollOrderBy = "SerialNoWise";  
      else if (data.IsNameWise) payrollOrderBy = "NameWise";
      else if (data.IsCardNoWise) payrollOrderBy = "CardNoWise";

      setState((prev) => ({
        ...prev,
        id: data.Id || 0,
        formData: {
          // ── Basic Information ──
          EmployerName: data.EmployerName || "",
          Address: data.Address || "",
          Designation: data.Designation || "",
          Bank: data.Bank || "",
          CreatePayrollAutomatically: !!data.IsAutoPayroll,
          PayrollOrderBy: payrollOrderBy,
          DepartmentWisePayroll: !!data.IsDepartmentWisePayroll,
          RetirementAge: data.RetirementAge || "",
          MinWages: data.MinWages || "",
          ESIOnOT: !!data.IsESIOnOT,
          PFOnOT: !!data.IsPFOnOT,
          SundayInclude: !!data.IsSundayInclude,
          SundayIncludeDeptwise: !!data.IsSundayDeptWise,
          HourlyPayment: !!data.IsHourlyPayment,
          WagesRoundedOff: !!data.IsWagesRoundedOff,
          ArrearApplicable: !!data.IsArrearApplicable,
          PFOnArrear: !!data.IsPFOnArrear,
          ESIOnArrear: !!data.IsESIOnArrear,
          AllowancesOnArrear: !!data.IsAllowanceOnArrear,
          DirectWagesEntry: !!data.IsDirectWagesEntry,
          DirectWagesDepartmentwise: !!data.IsDirectWagesDeptWise,
          NetPayableRoundedOff: !!data.IsNetPayRounded,
          CopyDaysToNextEmployee: !!data.IsCopyDaysNextEmployee,
          MonthDayWithWHInBonus: !!data.IsMonthDayWithINBonus,
          LeaveWagesAmountOnBasicSalary: !!data.IsLeaveOnBasicSalary,
          DisplayLeaveWagesPayment: !!data.IsDisplayLeaveWithWages,
          OpLeaveWWagesInPayrollT: !!data.IsOpenLeaveWithWages,
          LeaveWithWagesDepartmentwise: !!data.IsLeaveDepartmentWise,
          GratuityEligibilityMonths: data.GratuityEligibilityMonths || "",
          GratuityPayableDaysInMonth: data.GratuityPayableDays || "",
          ShowCompanyNameInDepartment: false,
          MultiESICode: false,
          MultiPF: false,
          MultiFactoryFirm: false,
          AllowanceDeductionEditable: false,
          AddOvertimeAmountInNetPayable: !!data.IsAddOvertimeInNet,
          DontShowNCPInForm10C: !!data.IsHideNCPInForm16,
          CheckDuplicatePFNoEntry: !!data.IsCheckDuplicatePF,
          CheckDuplicateESINoEntry: !!data.IsCheckDuplicateESI,
          ShowForm3AWith0: !!data.IsShowForm3AZero,
          NoWeeklyHolidayForDailyWages: !!data.IsNoWeeklyHolidayDailyWages,
          NoDataOfContractor: !!data.IsNoContractorData,
          NoPensionDataInWagesRegister: !!data.IsNoPensionData,
          BasicEditable: !!data.IsBasicEditable,
          CRLOnMonthDays: !!data.IsCRLOnMonthDays,
          FirmHoliday: data.F_FirmHoliday || "",
          PFESIDuePaidDepartmentwise: !!data.IsPFESIDeptWise,
          AskToUpdatePaid: !!data.IsAskUpdatePaid,
          PieceWiseCalculation: !!data.IsPieceWiseCalculation,
          // ── Other Information ──
          ESIEnabled: !!data.IsESI,
          PFEnabled: !!data.IsPF,
          GratuityRates: !!data.IsGratuity,
          CRLDays: !!data.IsCRLDays,
          OverTime: !!data.IsOvertime,
          Recovery: !!data.IsRecovery,
          Advance: !!data.IsAdvance,
          TDS: !!data.IsTDS,
          AdvanceBonus: !!data.IsAdvanceBonus,
          PFAdvRefund: !!data.IsPFAdvRefund,
          PFSection: data.PFSection || "",
          MaxLwW: "",
          LwWUsage: "",
          MultiDepartmentSelection: !!data.IsMultiDepartment,
          Days26Working: !!data.Is26DaysWorking,
          Days26WorkingEmployeeWise: !!data.Is26DaysEmployeeWise,
          AddAbsentInPFChallan: !!data.IsAddAbsentInPF,
          BonusOnWorkingDays: !!data.IsBonusOnWorkingDays,
          MonthDayWOSundayForDailyWages: !!data.IsMonthDayWithoutSunday,
          AC2122OnFixedMaxPFWages: !!data.IsAC212OnFixedPF,
          DepartmentInWagesRegisterOrderWise: !!data.IsDeptOrderWise,
          OverLimitESICalcOnESILimit: !!data.IsOverLimitESI,
          FullESIByEmployer: !!data.IsFullESIEmployer,
          TransactionLocked: !!data.IsTransactionLocked,
          OvertimeOnGrossWages: !!data.IsOTOnGross,
          EntryFromExternal: !!data.IsEntryFromExternal,
          DoubleOvertimeAmount: !!data.IsDoubleOT,
          BonusOnMinWages: !!data.IsBonusOnMinWages,
          MinWagesEditable: !!data.IsMinWagesEditable,
          FullPFByEmployer: !!data.IsFullPFEmployer,
          MaxWHValidate: !!data.IsMaxWHValidate,
          OvertimeOn26Days: !!data.IsOTOn26Days,
          ExtraPay: !!data.IsExtraPay,
          PFOnExtraPay: !!data.IsPFOnExtraPay,
          ESIOnExtraPay: !!data.IsESIOnExtraPay,
          ExtraPayCaption: data.ExtraPayCaption || "",
          ExtraPay1: !!data.IsExtraPay1,
          PFOnExtraPay1: !!data.IsPFOnExtraPay1,
          ESIOnExtraPay1: !!data.IsESIOnExtraPay1,
          ExtraPayCaption1: data.ExtraPay1Caption || "",
          BonusMonthlyInPayroll: !!data.IsBonusMonthly,
          // ── Address Details ──
          FactoryActAddressDetails: "",
          PFAddressDetails: "",
          ESIAddressDetails: "",
        }
      }));
    }
    // ✅ If edit mode
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  };

  fetchData();
}, [dispatch, location.state]);

  const loadPfRecord = (rec) => {
    setPfForm({
      Id: rec.Id || 0,
      PFDate: rec.PFDate ? String(rec.PFDate).substring(0, 10) : "",
      Rate: rec.Rate || "", EmployerRate: rec.EmployerRate || "",
      PensionRate: rec.PensionRate || "", MaxPensionAmt: rec.MaxPensionAmt || "",
      MaxWagesForPF: rec.MaxWagesForPF || "", MaxWagesForPension: rec.MaxWagesForPension || "",
      AdminCharges: rec.AdminCharges || "", AdminChargesMinAmount: rec.AdminChargesMinAmount || "",
      AC21WithGroupIns: rec.AC21WithGroupIns || "", AC21WithGroupInsMinAmt: rec.AC21WithGroupInsMinAmt || "",
      AC22WithGroupIns: rec.AC22WithGroupIns || "", AC22WithGroupInsMinAmt: rec.AC22WithGroupInsMinAmt || "",
      AC21WithoutGroupIns: rec.AC21WithoutGroupIns || "", AC22WithoutGroupIns: rec.AC22WithoutGroupIns || "",
      HigherPensionRate: rec.HigherPensionRate || "",
      PFBasis: !!rec.PFBasis, PensionOnArrear: !!rec.PensionOnArrear, AC21Individually: !!rec.AC21Individually,
      NewLabourCodeApplyDate: rec.NewLabourCodeApplyDate ? String(rec.NewLabourCodeApplyDate).substring(0, 10) : "",
      NewLabourCodeBasicPrec: rec.NewLabourCodeBasicPrec || "",
    });
  };

  const navigatePf = (idx) => {
    if (!pfRecords.length) return;
    const i = Math.max(0, Math.min(pfRecords.length - 1, idx));
    setPfIndex(i);
    loadPfRecord(pfRecords[i]);
    setPfEditMode(false);
  };

  const PfParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/PfParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.PFDate) - new Date(b.PFDate));
      setPfRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setPfIndex(latestIdx);
        loadPfRecord(sorted[latestIdx]);
        setPfEditMode(false);
      } else {
        setPfForm({ ...pfFormInit });
        setPfEditMode(true);
      }
    } catch {
      setPfRecords([]);
      setPfForm({ ...pfFormInit });
      setPfEditMode(true);
    }
  };

  // Restore JSON rows on edit
  useEffect(() => {
    const f = state.formData;
    if (!f) return;
    // No longer needed for allowance/deduction
  }, [state.formData]);



  const handlePFSave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);
      Object.entries(pfForm).forEach(([k, v]) => { if (k !== "Id") fd.append(k, v || ""); });
      fd.append("UserId", 0);
      await Fn_AddEditData(dispatch, setState, { arguList: { id: pfForm.Id, formData: fd } }, "PFParameter/0/token", true, "memberid", navigate, "#");
      // Refresh records after save
      await PfParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const loadEsiRecord = (rec) => {
    setEsiForm({
      Id: rec.Id || 0,
      ESIDate: rec.ESIDate ? String(rec.ESIDate).substring(0, 10) : "",
      EmployeeContribution: rec.EmployeeContribution || "",
      EmployerContribution: rec.EmployerContribution || "",
      WagesLimit: rec.WagesLimit || "",
      RoundedOn: !!rec.RoundedOn,
      EmployerPartIndividually: !!rec.EmployerPartIndividually,
      EmployeeExemptionLimit: rec.EmployeeExemptionLimit || "",
      Rural: !!rec.Rural,
      NewLabourCodeApplyDate: rec.NewLabourCodeApplyDate ? String(rec.NewLabourCodeApplyDate).substring(0, 10) : "",
      NewLabourCodeBasicPrec: rec.NewLabourCodeBasicPrec || "",
    });
  };

  const loadBonusRecord = (rec) => {
    setBonusForm({
      Id: rec.Id || 0,
      BonusDate: rec.BonusDate ? String(rec.BonusDate).substring(0, 10) : "",
      BonusRate: rec.BonusRate || "",
      MaximumWages: rec.MaximumWages || "",
      MaximumWagesLimit: rec.MaximumWagesLimit || "",
      MaximumBonus: rec.MaximumBonus || "",
      MinimumBonus: rec.MinimumBonus || "",
      MinimumBonusDays: rec.MinimumBonusDays || "",
    });
  };

  const loadGratuityRecord = (rec) => {
    setGratuityForm({
      Id: rec.Id || 0,
      GratuityDate: rec.GratuityDate ? String(rec.GratuityDate).substring(0, 10) : "",
      Rate: rec.Rate || "",
    });
  };

  const navigateEsi = (idx) => {
    if (!esiRecords.length) return;
    const i = Math.max(0, Math.min(esiRecords.length - 1, idx));
    setEsiIndex(i);
    loadEsiRecord(esiRecords[i]);
    setEsiEditMode(false);
  };

  const navigateBonus = (idx) => {
    if (!bonusRecords.length) return;
    const i = Math.max(0, Math.min(bonusRecords.length - 1, idx));
    setBonusIndex(i);
    loadBonusRecord(bonusRecords[i]);
    setBonusEditMode(false);
  };

  const navigateGratuity = (idx) => {
    if (!gratuityRecords.length) return;
    const i = Math.max(0, Math.min(gratuityRecords.length - 1, idx));
    setGratuityIndex(i);
    loadGratuityRecord(gratuityRecords[i]);
    setGratuityEditMode(false);
  };

  const EsiParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/EsiParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.ESIDate) - new Date(b.ESIDate));
      setEsiRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setEsiIndex(latestIdx);
        loadEsiRecord(sorted[latestIdx]);
        setEsiEditMode(false);
      } else {
        setEsiForm({ ...esiFormInit });
        setEsiEditMode(true);
      }
    } catch {
      setEsiRecords([]);
      setEsiForm({ ...esiFormInit });
      setEsiEditMode(true);
    }
  };

  const BonusParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/BonusParamFetch/TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.BonusDate) - new Date(b.BonusDate));
      setBonusRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setBonusIndex(latestIdx);
        loadBonusRecord(sorted[latestIdx]);
        setBonusEditMode(false);
      } else {
        setBonusForm({ ...bonusFormInit });
        setBonusEditMode(true);
      }
    } catch {
      setBonusRecords([]);
      setBonusForm({ ...bonusFormInit });
      setBonusEditMode(true);
    }
  };

  const GratuityParamFetch = async (firmId) => {
    try {
      const res = await Fn_FillListData(dispatch, () => {}, "Data", `${API_WEB_URLS.MASTER}/0/token/
      /TBL.F_FirmMaster/${firmId}`);
      const sorted = (res || []).sort((a, b) => new Date(a.GratuityDate) - new Date(b.GratuityDate));
      setGratuityRecords(sorted);
      if (sorted.length > 0) {
        const latestIdx = sorted.length - 1;
        setGratuityIndex(latestIdx);
        loadGratuityRecord(sorted[latestIdx]);
        setGratuityEditMode(false);
      } else {
        setGratuityForm({ ...gratuityFormInit });
        setGratuityEditMode(true);
      }
    } catch {
      setGratuityRecords([]);
      setGratuityForm({ ...gratuityFormInit });
      setGratuityEditMode(true);
    }
  };

  const handleESISave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);
      Object.entries(esiForm).forEach(([k, v]) => { if (k !== "Id") fd.append(k, v || ""); });
      fd.append("UserId", 0);
      await Fn_AddEditData(dispatch, setState, { arguList: { id: esiForm.Id, formData: fd } }, "ESISettings/0/token", true, "memberid", navigate, "#");
      await EsiParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const handleBonusSave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);
      Object.entries(bonusForm).forEach(([k, v]) => { if (k !== "Id") fd.append(k, v || ""); });
      fd.append("UserId", 0);
      await Fn_AddEditData(dispatch, setState, { arguList: { id: bonusForm.Id, formData: fd } }, "BonusParameter/0/token", true, "memberid", navigate, "#");
      await BonusParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const handleGratuitySave = async () => {
    try {
      const fd = new FormData();
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);
      Object.entries(gratuityForm).forEach(([k, v]) => { if (k !== "Id") fd.append(k, v || ""); });
      fd.append("UserId", 0);
      await Fn_AddEditData(dispatch, setState, { arguList: { id: gratuityForm.Id, formData: fd } }, "GratuityParameter/0/token", true, "memberid", navigate, "#");
      await GratuityParamFetch(firmId);
    } catch (e) { console.error(e); }
  };

  const handleSubmit = async (values) => {
    try {
      const fd = new FormData();
      
      // F_FirmMaster is required for save
      const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0;
      fd.append("F_FirmMaster", firmId);

      // ── Basic Information ──
      fd.append("EmployerName",                    values.EmployerName                    || "");
      fd.append("Address",                         values.Address                         || "");
      fd.append("Designation",                     values.Designation                     || "");
      fd.append("Bank",                            values.Bank                            || "");
      fd.append("IsAutoPayroll",                   values.CreatePayrollAutomatically      ? true : false);
      
      // PayrollOrderBy maps to separate boolean fields
      fd.append("IsPFNoWise",                      values.PayrollOrderBy === "PFNoWise" ? true : false);
      fd.append("IsSerialNoWise",                  values.PayrollOrderBy === "SerialNoWise" ? true : false);
      fd.append("IsNameWise",                      values.PayrollOrderBy === "NameWise" ? true : false);
      fd.append("IsCardNoWise",                    values.PayrollOrderBy === "CardNoWise" ? true : false);
      
      fd.append("IsDepartmentWisePayroll",         values.DepartmentWisePayroll           ? true : false);
      fd.append("RetirementAge",                   values.RetirementAge                   || "");
      fd.append("MinWages",                        values.MinWages                        || "");
      fd.append("IsESIOnOT",                       values.ESIOnOT                         ? true : false);
      fd.append("IsPFOnOT",                        values.PFOnOT                          ? true : false);
      fd.append("IsSundayInclude",                 values.SundayInclude                   ? true : false);
      fd.append("IsSundayDeptWise",                values.SundayIncludeDeptwise           ? true : false);
      fd.append("IsHourlyPayment",                 values.HourlyPayment                   ? true : false);
      fd.append("IsWagesRoundedOff",               values.WagesRoundedOff                 ? true : false);
      fd.append("IsArrearApplicable",              values.ArrearApplicable                ? true : false);
      fd.append("IsPFOnArrear",                    values.PFOnArrear                      ? true : false);
      fd.append("IsESIOnArrear",                   values.ESIOnArrear                     ? true : false);
      fd.append("IsAllowanceOnArrear",             values.AllowancesOnArrear              ? true : false);
      fd.append("IsDirectWagesEntry",              values.DirectWagesEntry                ? true : false);
      fd.append("IsDirectWagesDeptWise",           values.DirectWagesDepartmentwise       ? true : false);
      fd.append("IsNetPayRounded",                 values.NetPayableRoundedOff            ? true : false);
      fd.append("IsCopyDaysNextEmployee",          values.CopyDaysToNextEmployee          ? true : false);
      fd.append("IsMonthDayWithINBonus",           values.MonthDayWithWHInBonus           ? true : false);
      fd.append("IsLeaveOnBasicSalary",            values.LeaveWagesAmountOnBasicSalary   ? true : false);
      fd.append("IsDisplayLeaveWithWages",         values.DisplayLeaveWagesPayment        ? true : false);
      fd.append("IsOpenLeaveWithWages",            values.OpLeaveWWagesInPayrollT         ? true : false);
      fd.append("IsLeaveDepartmentWise",           values.LeaveWithWagesDepartmentwise    ? true : false);
      fd.append("GratuityEligibilityMonths",       values.GratuityEligibilityMonths       || "");
      fd.append("GratuityPayableDays",             values.GratuityPayableDaysInMonth      || "");
      // fd.append("ShowCompanyNameInDepartment",     values.ShowCompanyNameInDepartment     ? true : false); // Not in API
      // fd.append("MultiESICode",                    values.MultiESICode                    ? true : false); // Not in API
      // fd.append("MultiPF",                         values.MultiPF                         ? true : false); // Not in API
      // fd.append("MultiFactoryFirm",                values.MultiFactoryFirm                ? true : false); // Not in API
      // fd.append("AllowanceDeductionEditable",      values.AllowanceDeductionEditable      ? true : false); // Not in API
      fd.append("IsAddOvertimeInNet",              values.AddOvertimeAmountInNetPayable   ? true : false);
      fd.append("IsHideNCPInForm16",               values.DontShowNCPInForm10C            ? true : false);
      fd.append("IsCheckDuplicatePF",              values.CheckDuplicatePFNoEntry         ? true : false);
      fd.append("IsCheckDuplicateESI",             values.CheckDuplicateESINoEntry        ? true : false);
      fd.append("IsShowForm3AZero",                values.ShowForm3AWith0                 ? true : false);
      fd.append("IsNoWeeklyHolidayDailyWages",     values.NoWeeklyHolidayForDailyWages    ? true : false);
      fd.append("IsNoContractorData",              values.NoDataOfContractor              ? true : false);
      fd.append("IsNoPensionData",                 values.NoPensionDataInWagesRegister    ? true : false);
      fd.append("IsBasicEditable",                 values.BasicEditable                   ? true : false);
      fd.append("IsCRLOnMonthDays",                values.CRLOnMonthDays                  ? true : false);
      fd.append("F_FirmHoliday",                   values.FirmHoliday                     || "");
      fd.append("IsPFESIDeptWise",                 values.PFESIDuePaidDepartmentwise      ? true : false);
      fd.append("IsAskUpdatePaid",                 values.AskToUpdatePaid                 ? true : false);
      fd.append("IsPieceWiseCalculation",          values.PieceWiseCalculation            ? true : false);

      // ── Other Information ──
      fd.append("IsESI",                           values.ESIEnabled                      ? true : false);
      fd.append("IsPF",                            values.PFEnabled                       ? true : false);
      fd.append("IsGratuity",                      values.GratuityRates                   ? true : false);
      fd.append("IsCRLDays",                       values.CRLDays                         ? true : false);
      fd.append("IsOvertime",                      values.OverTime                        ? true : false);
      fd.append("IsRecovery",                      values.Recovery                        ? true : false);
      fd.append("IsAdvance",                       values.Advance                         ? true : false);
      fd.append("IsTDS",                           values.TDS                             ? true : false);
      fd.append("IsAdvanceBonus",                  values.AdvanceBonus                    ? true : false);
      fd.append("IsPFAdvRefund",                   values.PFAdvRefund                     ? true : false);
      fd.append("PFSection",                       values.PFSection                       || "");
      // fd.append("MaxLwW",                          values.MaxLwW                          || ""); // Not in API
      // fd.append("LwWUsage",                        values.LwWUsage                        || ""); // Not in API
      fd.append("IsMultiDepartment",               values.MultiDepartmentSelection        ? true : false);
      fd.append("Is26DaysWorking",                 values.Days26Working                   ? true : false);
      fd.append("Is26DaysEmployeeWise",            values.Days26WorkingEmployeeWise       ? true : false);
      fd.append("IsAddAbsentInPF",                 values.AddAbsentInPFChallan            ? true : false);
      fd.append("IsBonusOnWorkingDays",            values.BonusOnWorkingDays              ? true : false);
      fd.append("IsMonthDayWithoutSunday",         values.MonthDayWOSundayForDailyWages   ? true : false);
      fd.append("IsAC212OnFixedPF",                values.AC2122OnFixedMaxPFWages         ? true : false);
      fd.append("IsDeptOrderWise",                 values.DepartmentInWagesRegisterOrderWise ? true : false);
      fd.append("IsOverLimitESI",                  values.OverLimitESICalcOnESILimit      ? true : false);
      fd.append("IsFullESIEmployer",               values.FullESIByEmployer               ? true : false);
      fd.append("IsTransactionLocked",             values.TransactionLocked               ? true : false);
      fd.append("IsOTOnGross",                     values.OvertimeOnGrossWages            ? true : false);
      fd.append("IsEntryFromExternal",             values.EntryFromExternal               ? true : false);
      fd.append("IsDoubleOT",                      values.DoubleOvertimeAmount            ? true : false);
      fd.append("IsBonusOnMinWages",               values.BonusOnMinWages                 ? true : false);
      fd.append("IsMinWagesEditable",              values.MinWagesEditable                ? true : false);
      fd.append("IsFullPFEmployer",                values.FullPFByEmployer                ? true : false);
      fd.append("IsMaxWHValidate",                 values.MaxWHValidate                   ? true : false);
      fd.append("IsOTOn26Days",                    values.OvertimeOn26Days                ? true : false);
      fd.append("IsExtraPay",                      values.ExtraPay                        ? true : false);
      fd.append("IsPFOnExtraPay",                  values.PFOnExtraPay                    ? true : false);
      fd.append("IsESIOnExtraPay",                 values.ESIOnExtraPay                   ? true : false);
      fd.append("ExtraPayCaption",                 values.ExtraPayCaption                 || "");
      fd.append("IsExtraPay1",                     values.ExtraPay1                       ? true : false);
      fd.append("IsPFOnExtraPay1",                 values.PFOnExtraPay1                   ? true : false);
      fd.append("IsESIOnExtraPay1",                values.ESIOnExtraPay1                  ? true : false);
      fd.append("ExtraPay1Caption",                values.ExtraPayCaption1                || "");
      fd.append("IsBonusMonthly",                  values.BonusMonthlyInPayroll           ? true : false);

      // ── Address Details ──
      // fd.append("FactoryActAddressDetails",        values.FactoryActAddressDetails        || ""); // Not in API
      // fd.append("PFAddressDetails",                values.PFAddressDetails                || ""); // Not in API
      // fd.append("ESIAddressDetails",               values.ESIAddressDetails               || ""); // Not in API

      Fn_AddEditData(
        dispatch, setState,
        { arguList: { id: 0, formData: fd } },
        API_URL_SAVE, true, "memberid", navigate, "/PayrollParameter"
      );
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again.");
    }
  };

  const tabs = [
    { key: "basicInfo",     label: "BASIC INFORMATION" },
    { key: "otherInfo",     label: "OTHER INFORMATION" },
    { key: "addressDetails", label: "ADDRESS DETAILS" },
  ];

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Payroll Parameter" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Payroll Parameter</h4>
            </div>
            <div className="card-body">

              <Formik
                initialValues={state.formData}
                enableReinitialize
                validationSchema={ParamSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => { handleSubmit(values); setSubmitting(false); }, 400);
                }}
              >
                {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => {
                  const sf = (name) => (e) => setFieldValue(name, e.target.checked);
                  return (
                    <form onSubmit={handleSubmit}>

                      {/* ── Tabs ── */}
                      <ul className="nav nav-tabs mb-3" role="tablist">
                        {tabs.map((t) => (
                          <li className="nav-item" key={t.key}>
                            <button
                              type="button"
                              className={`nav-link${activeTab === t.key ? " active" : ""}`}
                              onClick={() => setActiveTab(t.key)}
                            >
                              {t.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      {/* ══════════════════════════════════════
                           TAB 1 — BASIC INFORMATION
                         ══════════════════════════════════════ */}
                      {activeTab === "basicInfo" && (
                        <div>
                          {/* Row 1: Employer Name + Address */}
                          <div className="row mb-2">
                            <div className="col-md-3">
                              <label className="text-label" style={{ fontSize: 12 }}>EMPLOYER NAME</label>
                              <input type="text" className="form-control form-control-sm" name="EmployerName" value={values.EmployerName} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-5">
                              <label className="text-label" style={{ fontSize: 12 }}>ADDRESS</label>
                              <input type="text" className="form-control form-control-sm" name="Address" value={values.Address} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-2">
                              <label className="text-label" style={{ fontSize: 12 }}>DESIGNATION</label>
                              <input type="text" className="form-control form-control-sm" name="Designation" value={values.Designation} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-md-2">
                              <label className="text-label" style={{ fontSize: 12 }}>BANK</label>
                              <input type="text" className="form-control form-control-sm" name="Bank" value={values.Bank} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                          </div>

                          {/* Row 2: Create Payroll + radio order */}
                          <div className="row mb-2 align-items-center">
                            <div className="col-auto d-flex align-items-center">
                              <input type="checkbox" className="form-check-input me-1" id="CreatePayrollAutomatically" checked={!!values.CreatePayrollAutomatically} onChange={sf("CreatePayrollAutomatically")} />
                              <label htmlFor="CreatePayrollAutomatically" style={{ fontSize: 12, cursor: "pointer" }}>CREATE PAYROLL AUTOMATICALLY</label>
                            </div>
                            {["PFNoWise","SerialNoWise","NameWise","CardNoWise"].map((opt) => (
                              <div key={opt} className="col-auto d-flex align-items-center">
                                <input type="radio" name="PayrollOrderBy" className="form-check-input me-1" value={opt} checked={values.PayrollOrderBy === opt} onChange={handleChange} />
                                <label style={{ fontSize: 12 }}>{opt.replace("Wise"," Wise")}</label>
                              </div>
                            ))}
                          </div>

                          {/* Row 3: Dept wise + Retirement + Place */}
                          <div className="row mb-3 align-items-center">
                            <div className="col-auto d-flex align-items-center">
                              <input type="checkbox" className="form-check-input me-1" id="DepartmentWisePayroll" checked={!!values.DepartmentWisePayroll} onChange={sf("DepartmentWisePayroll")} />
                              <label htmlFor="DepartmentWisePayroll" style={{ fontSize: 12, cursor: "pointer" }}>DEPARTMENT WISE PAYROLL</label>
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12 }}>RETIREMENT AGE</label>
                              <input type="number" className="form-control form-control-sm" style={{ width: 70 }} name="RetirementAge" value={values.RetirementAge} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <label style={{ fontSize: 12 }}>MIN WAGES</label>
                              <input type="number" className="form-control form-control-sm" style={{ width: 80 }} name="MinWages" value={values.MinWages} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                            <div className="col-auto d-flex align-items-center gap-2">
                              <input type="checkbox" className="form-check-input me-1" id="ESIOnOT" checked={!!values.ESIOnOT} onChange={sf("ESIOnOT")} />
                              <label htmlFor="ESIOnOT" style={{ fontSize: 12, cursor: "pointer" }}>ESI ON OT</label>
                              <input type="checkbox" className="form-check-input ms-2 me-1" id="PFOnOT" checked={!!values.PFOnOT} onChange={sf("PFOnOT")} />
                              <label htmlFor="PFOnOT" style={{ fontSize: 12, cursor: "pointer" }}>PF ON OT</label>
                            </div>
                          </div>

                          {/* Checkbox grid – 3 columns */}
                          <div className="row">
                            {/* Column 1 */}
                            <div className="col-md-4">
                              {[
                                ["SundayInclude",            "SUNDAY INCLUDE"],
                                ["SundayIncludeDeptwise",    "SUNDAY INCLUDE DEPTWISE"],
                                ["HourlyPayment",            "HOURLY PAYMENT"],
                                ["WagesRoundedOff",          "WAGES ROUNDED OFF"],
                                ["ArrearApplicable",         "ARREAR APPLICABLE"],
                                ["PFOnArrear",               "PF ON ARREAR"],
                                ["ESIOnArrear",              "ESI ON ARREAR"],
                                ["AllowancesOnArrear",       "ALLOWANCES ON ARREAR"],
                                ["DirectWagesEntry",         "DIRECT WAGES ENTRY"],
                                ["DirectWagesDepartmentwise","DIRECT WAGES DEPARTMENTWISE"],
                                ["NetPayableRoundedOff",     "NET PAYABLE ROUNDED OFF"],
                                ["CopyDaysToNextEmployee",   "COPY DAYS TO NEXT EMPLOYEE"],
                                ["MonthDayWithWHInBonus",    "MONTH DAY WITH WH IN BONUS"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                            </div>

                            {/* Column 2 */}
                            <div className="col-md-4">
                              {[
                                ["LeaveWagesAmountOnBasicSalary", "LEAVE WAGES AMOUNT ON BASIC SALARY"],
                                ["DisplayLeaveWagesPayment",      "DISPLAY LEAVE W/WAGES PAYMENT"],
                                ["OpLeaveWWagesInPayrollT",       "OP. LEAVE W/WAGES IN PAYROLL T"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                              {[
                                ["LeaveWithWagesDepartmentwise", "LEAVE WITH WAGES DEPARTMENTWISE"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 200 }}>GRATUITY ELIGIBILITY MONTHS</label>
                                <input type="number" className="form-control form-control-sm ms-1" style={{ width: 60 }} name="GratuityEligibilityMonths" value={values.GratuityEligibilityMonths} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 200 }}>GRATUITY PAYABLE DAYS IN MONTH</label>
                                <input type="number" className="form-control form-control-sm ms-1" style={{ width: 60 }} name="GratuityPayableDaysInMonth" value={values.GratuityPayableDaysInMonth} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                              {[
                                ["ShowCompanyNameInDepartment", "SHOW COMPANY NAME IN DEPARTMENT"],
                                ["MultiESICode",                "MULTI ESI CODE"],
                                ["MultiPF",                     "MULTI PF"],
                                ["MultiFactoryFirm",            "MULTI FACTORY FIRM"],
                                ["AllowanceDeductionEditable",  "ALLOWANCE DEDUCTION EDITABLE"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                            </div>

                            {/* Column 3 */}
                            <div className="col-md-4">
                              {[
                                ["AddOvertimeAmountInNetPayable",  "ADD OVERTIME AMOUNT IN NET PAYABLE"],
                                ["DontShowNCPInForm10C",           "DONT SHOW NCP IN FORM 10C"],
                                ["CheckDuplicatePFNoEntry",        "CHECK DUPLICATE PF NO ENTRY"],
                                ["CheckDuplicateESINoEntry",       "CHECK DUPLICATE ESI NO ENTRY"],
                                ["ShowForm3AWith0",                "SHOW FORM 3A WITH 0"],
                                ["NoWeeklyHolidayForDailyWages",   "NO WEEKLY HOLIDAY FOR DAILY WAGES"],
                                ["NoDataOfContractor",             "NO DATA OF CONTRACTOR"],
                                ["NoPensionDataInWagesRegister",   "NO PENSION DATA IN WAGES REGISTER"],
                                ["BasicEditable",                  "BASIC EDITABLE"],
                                ["CRLOnMonthDays",                 "CRL ON MONTH DAYS"],
                                ["PFESIDuePaidDepartmentwise",     "PF ESI DUE PAID DEPARTMENTWISE"],
                                ["AskToUpdatePaid",                "ASK TO UPDATE PAID"],
                                ["PieceWiseCalculation",           "PIECE WISE CALCULATION"],
                              ].map(([name, label]) => (
                                <CB key={name} name={name} label={label} value={values[name]} onChange={sf(name)} col="" />
                              ))}
                              <div className="d-flex align-items-center mb-2">
                                <label style={{ fontSize: 12, minWidth: 120 }}>FIRM HOLIDAY</label>
                                <select className="form-control form-control-sm ms-1" style={{ width: 130 }} name="FirmHoliday" value={values.FirmHoliday} onChange={handleChange}>
                                  {["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"].map((d) => (
                                    <option key={d} value={d}>{d}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ══════════════════════════════════════
                           TAB 2 — OTHER INFORMATION
                         ══════════════════════════════════════ */}
                      {activeTab === "otherInfo" && (
                        <div className="row">
                          {/* Left panel */}
                          <div className="col-md-3 border-end pe-3">
                            {/* ESI / PF / Bonus / Gratuity Rates … */}
                            {[
                              { name: "ESIEnabled",    label: "ESI",            btnLabel: "ESI", onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setEsiModalOpen(true); EsiParamFetch(firmId); } },
                              { name: "PFEnabled",     label: "PF",             btnLabel: "PF",  onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setPfModalOpen(true); PfParamFetch(firmId); } },
                              { name: "BonusEnabled",  label: "Bonus",          btnLabel: "BONUS", onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setBonusModalOpen(true); BonusParamFetch(firmId); } },
                              { name: "GratuityRates", label: "Gratuity Rates", btnLabel: "GRA", onBtnClick: () => { const firmId = JSON.parse(localStorage.getItem("selectedFirm") || "{}").Id || 0; setGratuityModalOpen(true); GratuityParamFetch(firmId); } },
                            ].map(({ name, label, btnLabel, onBtnClick }) => (
                              <div key={name} className="d-flex align-items-center mb-2 gap-2">
                                <input type="checkbox" className="form-check-input" id={name} checked={!!values[name]} onChange={sf(name)} />
                                <label htmlFor={name} style={{ fontSize: 12, minWidth: 110, cursor: "pointer" }}>{label}</label>
                                <button type="button" className="btn btn-secondary btn-xs px-2 py-0" onClick={onBtnClick}>{btnLabel}</button>
                              </div>
                            ))}
                            {[
                              { label: "Group Insurance", btnLabel: "GI" },
                              { label: "Bidi Rates",      btnLabel: "Rates" },
                              { label: "Bonus Parameters",btnLabel: "Bonus" },
                            ].map(({ label, btnLabel }) => (
                              <div key={btnLabel} className="d-flex align-items-center mb-2 gap-2">
                                <span style={{ fontSize: 12, minWidth: 126 }}>{label}</span>
                                <button type="button" className="btn btn-secondary btn-xs px-2 py-0">{btnLabel}</button>
                              </div>
                            ))}

                            <hr className="my-2" />

                            {/* Leave / deduction checkboxes */}
                            {[
                              ["CRLDays",     "CRL Days"],
                              ["OverTime",    "OverTime"],
                              ["Recovery",    "Recovery"],
                              ["Advance",     "Advance"],
                              ["TDS",         "TDS"],
                              ["AdvanceBonus","Advance Bonus"],
                              ["PFAdvRefund", "PF Adv. Refund"],
                            ].map(([name, label]) => (
                              <div key={name} className="d-flex align-items-center mb-1">
                                <input type="checkbox" className="form-check-input me-2" id={name} checked={!!values[name]} onChange={sf(name)} />
                                <label htmlFor={name} style={{ fontSize: 12, cursor: "pointer" }}>{label}</label>
                              </div>
                            ))}

                            <hr className="my-2" />

                            <div className="d-flex align-items-center mb-2 gap-2">
                              <label style={{ fontSize: 12, minWidth: 90 }}>PF Section</label>
                              <input type="text" className="form-control form-control-sm" style={{ width: 100 }} name="PFSection" value={values.PFSection} onChange={handleChange} onBlur={handleBlur} />
                            </div>
                          </div>

                          {/* Middle panel */}
                          <div className="col-md-5 border-end pe-3">
                            {[
                              ["MultiDepartmentSelection",         "MULTI DEPARTMENT SELECTION"],
                              ["Days26Working",                    "26 DAYS WORKING"],
                              ["Days26WorkingEmployeeWise",        "26 DAYS WORKING EMPLOYEEWISE"],
                              ["AddAbsentInPFChallan",             "ADD ABSENT IN PF CHALLAN"],
                              ["BonusOnWorkingDays",               "BONUS ON WORKING DAYS"],
                              ["MonthDayWOSundayForDailyWages",    "MONTH DAY W/O SUNDAY FOR DAILY WAGES"],
                              ["AC2122OnFixedMaxPFWages",          "A/C 21 22 ON FIXED MAX PF WAGES"],
                              ["DepartmentInWagesRegisterOrderWise","DEPARTMENT IN WAGES REGISTER ORDER WISE"],
                              ["OverLimitESICalcOnESILimit",       "OVER LIMIT ESI CALCULATE ON ESI LIMIT"],
                              ["FullESIByEmployer",                "FULL ESI BY EMPLOYER"],
                              ["TransactionLocked",                "TRANSACTION LOCKED"],
                              ["OvertimeOnGrossWages",             "OVERTIME ON GROSS WAGES"],
                              ["EntryFromExternal",                "ENTRY FROM EXTERNAL"],
                              ["DoubleOvertimeAmount",             "DOUBLE OVERTIME AMOUNT"],
                              ["BonusOnMinWages",                  "BONUS ON MIN WAGES"],
                              ["MinWagesEditable",                 "MIN WAGES EDITABLE"],
                              ["FullPFByEmployer",                 "FULL PF BY EMPLOYER"],
                              ["MaxWHValidate",                    "MAX WH VALIDATE"],
                              ["OvertimeOn26Days",                 "OVERTIME ON 26 DAYS"],
                            ].map(([name, label]) => (
                              <div key={name} className="d-flex align-items-center mb-2">
                                <input type="checkbox" className="form-check-input me-2" id={name} checked={!!values[name]} onChange={sf(name)} />
                                <label htmlFor={name} style={{ fontSize: 12, cursor: "pointer" }}>{label}</label>
                              </div>
                            ))}
                          </div>

                          {/* Right panel – Extra Pay */}
                          <div className="col-md-4">
                            <div className="mb-3">
                              <h6 className="text-primary border-bottom pb-1" style={{ fontSize: 13 }}>Extra Pay</h6>
                              <div className="d-flex gap-2 mb-2 flex-wrap">
                                {[["ExtraPay","Extra Pay"],["PFOnExtraPay","PF on Extra Pay"],["ESIOnExtraPay","ESI on Extra Pay"]].map(([name,label]) => (
                                  <div key={name} className="d-flex align-items-center gap-1">
                                    <input type="checkbox" className="form-check-input" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} style={{ fontSize: 12, cursor: "pointer" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                              <div className="d-flex align-items-center mb-2 gap-2">
                                <label style={{ fontSize: 12, minWidth: 120 }}>Extra Pay Caption</label>
                                <input type="text" className="form-control form-control-sm" name="ExtraPayCaption" value={values.ExtraPayCaption} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                            </div>

                            <div className="mb-3">
                              <h6 className="text-primary border-bottom pb-1" style={{ fontSize: 13 }}>Extra Pay 1</h6>
                              <div className="d-flex gap-2 mb-2 flex-wrap">
                                {[["ExtraPay1","Extra Pay1"],["PFOnExtraPay1","PF on Extra Pay1"],["ESIOnExtraPay1","ESI on Extra Pay1"]].map(([name,label]) => (
                                  <div key={name} className="d-flex align-items-center gap-1">
                                    <input type="checkbox" className="form-check-input" id={name} checked={!!values[name]} onChange={sf(name)} />
                                    <label htmlFor={name} style={{ fontSize: 12, cursor: "pointer" }}>{label}</label>
                                  </div>
                                ))}
                              </div>
                              <div className="d-flex align-items-center mb-2 gap-2">
                                <label style={{ fontSize: 12, minWidth: 120 }}>Extra Pay Caption1</label>
                                <input type="text" className="form-control form-control-sm" name="ExtraPayCaption1" value={values.ExtraPayCaption1} onChange={handleChange} onBlur={handleBlur} />
                              </div>
                            </div>

                            <div className="d-flex align-items-center mt-3">
                              <input type="checkbox" className="form-check-input me-2" id="BonusMonthlyInPayroll" checked={!!values.BonusMonthlyInPayroll} onChange={sf("BonusMonthlyInPayroll")} />
                              <label htmlFor="BonusMonthlyInPayroll" style={{ fontSize: 12, cursor: "pointer" }}>Bonus (Monthly) in Payroll</label>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ══════════════════════════════════════
                           TAB 3 — ADDRESS DETAILS
                         ══════════════════════════════════════ */}
                      {activeTab === "addressDetails" && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>FACTORY ACT ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="FactoryActAddressDetails" value={values.FactoryActAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>PF ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="PFAddressDetails" value={values.PFAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <label className="text-label fw-bold" style={{ fontSize: 14 }}>ESI ADDRESS DETAILS</label>
                                  <textarea className="form-control" rows={6} name="ESIAddressDetails" value={values.ESIAddressDetails} onChange={handleChange} onBlur={handleBlur} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* ── Submit / Cancel ── */}
                      <div className="mt-4">
                        <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                          {isSubmitting ? "Saving..." : "Save"}
                        </button>
                        <button type="button" className="btn btn-danger light" onClick={() => navigate("/PayrollParameter")}>
                          Cancel
                        </button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {/* ── PF Rate Modal ── */}
      {pfModalOpen && (        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#d4d0c8", border: "2px solid #7a7a7a", width: 510, fontFamily: "Tahoma, Geneva, sans-serif", fontSize: 12, boxShadow: "6px 6px 16px rgba(0,0,0,0.6)" }}>
            {/* Title bar */}
            <div style={{ background: "#0a246a", color: "#fff", padding: "4px 10px", fontWeight: 700, fontSize: 13 }}>PF Rate</div>
            {/* Body */}
            {(() => {
              const ro = !pfEditMode;
              const iStyle = (w) => ({ width: w, height: 22, fontSize: 12, padding: "1px 4px", border: "1px solid #999", background: ro ? "#e8e8e8" : "#fff" });
              return (
                <div style={{ padding: "10px 14px" }}>
                  {[
                    ["DATE",                  "PFDate",             "date"],
                    ["RATE",                  "Rate",               "number"],
                    ["EMPLOYER RATE",         "EmployerRate",       "number"],
                    ["PENSION RATE",          "PensionRate",        "number"],
                    ["MAX PENSION AMT",       "MaxPensionAmt",      "number"],
                    ["MAX WAGES FOR PF",      "MaxWagesForPF",      "number"],
                    ["MAX WAGES FOR PENSION", "MaxWagesForPension", "number"],
                  ].map(([label, key, type]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type={type} style={iStyle(110)} readOnly={ro}
                        value={pfForm[key]} onChange={e => setPF(key, e.target.value)} />
                    </div>
                  ))}
                  {/* Admin Charges */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>ADMIN CHARGES</label>
                    <input type="number" style={iStyle(80)} readOnly={ro} value={pfForm.AdminCharges} onChange={e => setPF("AdminCharges", e.target.value)} />
                    <label style={{ marginLeft: 10, marginRight: 6, fontWeight: 600 }}>MIN. AMOUNT</label>
                    <input type="number" style={iStyle(70)} readOnly={ro} value={pfForm.AdminChargesMinAmount} onChange={e => setPF("AdminChargesMinAmount", e.target.value)} />
                  </div>
                  {/* A/C 21 With Group Ins */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>A/C 21 WITH GROUP INS</label>
                    <input type="number" style={iStyle(80)} readOnly={ro} value={pfForm.AC21WithGroupIns} onChange={e => setPF("AC21WithGroupIns", e.target.value)} />
                    <label style={{ marginLeft: 10, marginRight: 6, fontWeight: 600 }}>MIN. AMOUNT</label>
                    <input type="number" style={iStyle(70)} readOnly={ro} value={pfForm.AC21WithGroupInsMinAmt} onChange={e => setPF("AC21WithGroupInsMinAmt", e.target.value)} />
                  </div>
                  {/* A/C 22 With Group Ins */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>A/C 22 WITH GROUP INS</label>
                    <input type="number" style={iStyle(80)} readOnly={ro} value={pfForm.AC22WithGroupIns} onChange={e => setPF("AC22WithGroupIns", e.target.value)} />
                    <label style={{ marginLeft: 10, marginRight: 6, fontWeight: 600 }}>MIN. AMOUNT</label>
                    <input type="number" style={iStyle(70)} readOnly={ro} value={pfForm.AC22WithGroupInsMinAmt} onChange={e => setPF("AC22WithGroupInsMinAmt", e.target.value)} />
                  </div>
                  {[
                    ["A/C 21 WO GROUP INS", "AC21WithoutGroupIns"],
                    ["A/C 22 WO GROUP INS", "AC22WithoutGroupIns"],
                    ["HIGHER PENSION RATE", "HigherPensionRate"],
                  ].map(([label, key]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type="number" style={iStyle(110)} readOnly={ro} value={pfForm[key]} onChange={e => setPF(key, e.target.value)} />
                    </div>
                  ))}
                  {/* Checkboxes */}
                  {[
                    ["PF BASIS",           "PFBasis"],
                    ["PENSION ON ARREAR",  "PensionOnArrear"],
                    ["AC 21 INDIVIDUALLY", "AC21Individually"],
                  ].map(([label, key]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type="checkbox" disabled={ro} checked={!!pfForm[key]} onChange={e => setPF(key, e.target.checked)} style={{ width: 14, height: 14 }} />
                    </div>
                  ))}
                  {/* New Labour Code */}
                  {[
                    ["NEW LABOUR CODE APPLY DATE :", "NewLabourCodeApplyDate", "date"],
                    ["NEW LABOUR CODE BASIC PREC.:", "NewLabourCodeBasicPrec", "number"],
                  ].map(([label, key, type]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 195, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type={type} style={iStyle(110)} readOnly={ro} value={pfForm[key]} onChange={e => setPF(key, e.target.value)} />
                    </div>
                  ))}
                </div>
              );
            })()}
            {/* Buttons + Navigation */}
            <div style={{ borderTop: "1px solid #aaa", padding: "6px 14px 8px" }}>
              {/* Action buttons */}
              <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 6 }}>
                <button type="button" onClick={() => { setPfForm({ ...pfFormInit }); setPfEditMode(true); }}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Add</button>
                {pfEditMode
                  ? <button type="button" onClick={handlePFSave}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#c8e6c9", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Save</button>
                  : <button type="button" onClick={() => setPfEditMode(true)}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#fff9c4", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Edit</button>
                }
                <button type="button" onClick={() => setPfModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Cancel</button>
                <button type="button" onClick={() => setPfModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Exit</button>
              </div>
              {/* Record navigation */}
              {pfRecords.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                  {[["|\u25C4", 0], ["\u25C4", pfIndex - 1]].map(([lbl, idx]) => (
                    <button key={lbl} type="button" onClick={() => navigatePf(idx)} disabled={pfIndex === 0}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: pfIndex === 0 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                  <span style={{ fontSize: 11, padding: "1px 10px", border: "1px solid #aaa", background: "#fff", minWidth: 120, textAlign: "center" }}>
                    {pfRecords[pfIndex]?.PFDate ? new Date(pfRecords[pfIndex].PFDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : ""}
                  </span>
                  {["\u25BA", "\u25BA|"].map((lbl, i) => (
                    <button key={lbl} type="button" onClick={() => navigatePf(i === 0 ? pfIndex + 1 : pfRecords.length - 1)} disabled={pfIndex === pfRecords.length - 1}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: pfIndex === pfRecords.length - 1 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── ESI Rate Modal ── */}
      {esiModalOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#d4d0c8", border: "2px solid #7a7a7a", width: 480, fontFamily: "Tahoma, Geneva, sans-serif", fontSize: 12, boxShadow: "6px 6px 16px rgba(0,0,0,0.6)" }}>
            {/* Title bar */}
            <div style={{ background: "#0a246a", color: "#fff", padding: "4px 10px", fontWeight: 700, fontSize: 13 }}>ESI</div>
            {/* Body */}
            {(() => {
              const ro = !esiEditMode;
              const iStyle = (w) => ({ width: w, height: 22, fontSize: 12, padding: "1px 4px", border: "1px solid #999", background: ro ? "#e8e8e8" : "#fff" });
              return (
                <div style={{ padding: "10px 14px" }}>
                  {/* W.E.F. DATE */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>W.E.F. DATE :</label>
                    <input type="date" style={iStyle(120)} readOnly={ro}
                      value={esiForm.ESIDate} onChange={e => setESI("ESIDate", e.target.value)} />
                  </div>
                  {/* Numeric fields */}
                  {[
                    ["EMPLOYEE  CONTRIBUTION :", "EmployeeContribution"],
                    ["EMPLOYER CONTRIBUTION:",   "EmployerContribution"],
                    ["WAGES LIMIT :",            "WagesLimit"],
                  ].map(([label, key]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type="number" style={iStyle(120)} readOnly={ro}
                        value={esiForm[key]} onChange={e => setESI(key, e.target.value)} />
                    </div>
                  ))}
                  {/* Checkboxes */}
                  {[
                    ["ROUNDED ON :",              "RoundedOn"],
                    ["EMPLOYER PART INDIVIDUALLY :", "EmployerPartIndividually"],
                  ].map(([label, key]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type="checkbox" disabled={ro} checked={!!esiForm[key]} onChange={e => setESI(key, e.target.checked)} style={{ width: 14, height: 14 }} />
                    </div>
                  ))}
                  {/* Employee Exemption Limit */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>EMPLOYEE EXEMPTION LIMIT :</label>
                    <input type="number" style={iStyle(120)} readOnly={ro}
                      value={esiForm.EmployeeExemptionLimit} onChange={e => setESI("EmployeeExemptionLimit", e.target.value)} />
                  </div>
                  {/* Rural checkbox */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>RURAL :</label>
                    <input type="checkbox" disabled={ro} checked={!!esiForm.Rural} onChange={e => setESI("Rural", e.target.checked)} style={{ width: 14, height: 14 }} />
                  </div>
                  {/* New Labour Code */}
                  {[
                    ["NEW LABOUR CODE APPLY DATE :", "NewLabourCodeApplyDate", "date"],
                    ["NEW LABOUR CODE BASIC PREC.:", "NewLabourCodeBasicPrec", "number"],
                  ].map(([label, key, type]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type={type} style={iStyle(120)} readOnly={ro}
                        value={esiForm[key]} onChange={e => setESI(key, e.target.value)} />
                    </div>
                  ))}
                </div>
              );
            })()}
            {/* Buttons + Navigation */}
            <div style={{ borderTop: "1px solid #aaa", padding: "6px 14px 8px" }}>
              <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 6 }}>
                <button type="button" onClick={() => { setEsiForm({ ...esiFormInit }); setEsiEditMode(true); }}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Add</button>
                {esiEditMode
                  ? <button type="button" onClick={handleESISave}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#c8e6c9", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Save</button>
                  : <button type="button" onClick={() => setEsiEditMode(true)}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#fff9c4", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Edit</button>
                }
                <button type="button" onClick={() => setEsiModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Cancel</button>
                <button type="button" onClick={() => setEsiModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Exit</button>
              </div>
              {/* Record navigation */}
              {esiRecords.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                  {[["|\u25C4", 0], ["\u25C4", esiIndex - 1]].map(([lbl, idx]) => (
                    <button key={lbl} type="button" onClick={() => navigateEsi(idx)} disabled={esiIndex === 0}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: esiIndex === 0 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                  <span style={{ fontSize: 11, padding: "1px 10px", border: "1px solid #aaa", background: "#fff", minWidth: 120, textAlign: "center" }}>
                    {esiRecords[esiIndex]?.ESIDate ? new Date(esiRecords[esiIndex].ESIDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : ""}
                  </span>
                  {["\u25BA", "\u25BA|"].map((lbl, i) => (
                    <button key={lbl} type="button" onClick={() => navigateEsi(i === 0 ? esiIndex + 1 : esiRecords.length - 1)} disabled={esiIndex === esiRecords.length - 1}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: esiIndex === esiRecords.length - 1 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Bonus Rate Modal ── */}
      {bonusModalOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#d4d0c8", border: "2px solid #7a7a7a", width: 480, fontFamily: "Tahoma, Geneva, sans-serif", fontSize: 12, boxShadow: "6px 6px 16px rgba(0,0,0,0.6)" }}>
            {/* Title bar */}
            <div style={{ background: "#0a246a", color: "#fff", padding: "4px 10px", fontWeight: 700, fontSize: 13 }}>Bonus</div>
            {/* Body */}
            {(() => {
              const ro = !bonusEditMode;
              const iStyle = (w) => ({ width: w, height: 22, fontSize: 12, padding: "1px 4px", border: "1px solid #999", background: ro ? "#e8e8e8" : "#fff" });
              return (
                <div style={{ padding: "10px 14px" }}>
                  {/* W.E.F. DATE */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>W.E.F. DATE :</label>
                    <input type="date" style={iStyle(120)} readOnly={ro}
                      value={bonusForm.BonusDate} onChange={e => setBonus("BonusDate", e.target.value)} />
                  </div>
                  {/* Numeric fields */}
                  {[
                    ["BONUS RATE :", "BonusRate"],
                    ["MAXIMUM WAGES:", "MaximumWages"],
                    ["MAXIMUM WAGES LIMIT :", "MaximumWagesLimit"],
                    ["MAXIMUM BONUS :", "MaximumBonus"],
                    ["MINIMUM BONUS :", "MinimumBonus"],
                    ["MINIMUM BONUS DAYS :", "MinimumBonusDays"],
                  ].map(([label, key]) => (
                    <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                      <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>{label}</label>
                      <input type="number" style={iStyle(120)} readOnly={ro}
                        value={bonusForm[key]} onChange={e => setBonus(key, e.target.value)} />
                    </div>
                  ))}
                </div>
              );
            })()}
            {/* Buttons + Navigation */}
            <div style={{ borderTop: "1px solid #aaa", padding: "6px 14px 8px" }}>
              <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 6 }}>
                <button type="button" onClick={() => { setBonusForm({ ...bonusFormInit }); setBonusEditMode(true); }}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Add</button>
                {bonusEditMode
                  ? <button type="button" onClick={handleBonusSave}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#c8e6c9", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Save</button>
                  : <button type="button" onClick={() => setBonusEditMode(true)}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#fff9c4", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Edit</button>
                }
                <button type="button" onClick={() => setBonusModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Cancel</button>
                <button type="button" onClick={() => setBonusModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Exit</button>
              </div>
              {/* Record navigation */}
              {bonusRecords.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                  {[["|\u25C4", 0], ["\u25C4", bonusIndex - 1]].map(([lbl, idx]) => (
                    <button key={lbl} type="button" onClick={() => navigateBonus(idx)} disabled={bonusIndex === 0}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: bonusIndex === 0 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                  <span style={{ fontSize: 11, padding: "1px 10px", border: "1px solid #aaa", background: "#fff", minWidth: 120, textAlign: "center" }}>
                    {bonusRecords[bonusIndex]?.BonusDate ? new Date(bonusRecords[bonusIndex].BonusDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : ""}
                  </span>
                  {["\u25BA", "\u25BA|"].map((lbl, i) => (
                    <button key={lbl} type="button" onClick={() => navigateBonus(i === 0 ? bonusIndex + 1 : bonusRecords.length - 1)} disabled={bonusIndex === bonusRecords.length - 1}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: bonusIndex === bonusRecords.length - 1 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Gratuity Rate Modal ── */}
      {gratuityModalOpen && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#d4d0c8", border: "2px solid #7a7a7a", width: 480, fontFamily: "Tahoma, Geneva, sans-serif", fontSize: 12, boxShadow: "6px 6px 16px rgba(0,0,0,0.6)" }}>
            {/* Title bar */}
            <div style={{ background: "#0a246a", color: "#fff", padding: "4px 10px", fontWeight: 700, fontSize: 13 }}>GRATUITY RATE</div>
            {/* Body */}
            {(() => {
              const ro = !gratuityEditMode;
              const iStyle = (w) => ({ width: w, height: 22, fontSize: 12, padding: "1px 4px", border: "1px solid #999", background: ro ? "#e8e8e8" : "#fff" });
              return (
                <div style={{ padding: "10px 14px" }}>
                  {/* DATE */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>DATE :</label>
                    <input type="date" style={iStyle(120)} readOnly={ro}
                      value={gratuityForm.GratuityDate} onChange={e => setGratuity("GratuityDate", e.target.value)} />
                  </div>
                  {/* RATE */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <label style={{ width: 210, textAlign: "right", paddingRight: 8, fontWeight: 600 }}>RATE :</label>
                    <input type="number" style={iStyle(120)} readOnly={ro}
                      value={gratuityForm.Rate} onChange={e => setGratuity("Rate", e.target.value)} />
                  </div>
                </div>
              );
            })()}
            {/* Buttons + Navigation */}
            <div style={{ borderTop: "1px solid #aaa", padding: "6px 14px 8px" }}>
              <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 6 }}>
                <button type="button" onClick={() => { setGratuityForm({ ...gratuityFormInit }); setGratuityEditMode(true); }}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Add</button>
                {gratuityEditMode
                  ? <button type="button" onClick={handleGratuitySave}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#c8e6c9", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Save</button>
                  : <button type="button" onClick={() => setGratuityEditMode(true)}
                      style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#fff9c4", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Edit</button>
                }
                <button type="button" onClick={() => setGratuityModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Cancel</button>
                <button type="button" onClick={() => setGratuityModalOpen(false)}
                  style={{ fontSize: 12, padding: "3px 18px", border: "1px solid #777", background: "#e0e0e0", borderRadius: 2, cursor: "pointer", minWidth: 50 }}>Exit</button>
              </div>
              {/* Record navigation */}
              {gratuityRecords.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                  {[["|\u25C4", 0], ["\u25C4", gratuityIndex - 1]].map(([lbl, idx]) => (
                    <button key={lbl} type="button" onClick={() => navigateGratuity(idx)} disabled={gratuityIndex === 0}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: gratuityIndex === 0 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                  <span style={{ fontSize: 11, padding: "1px 10px", border: "1px solid #aaa", background: "#fff", minWidth: 120, textAlign: "center" }}>
                    {gratuityRecords[gratuityIndex]?.GratuityDate ? new Date(gratuityRecords[gratuityIndex].GratuityDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : ""}
                  </span>
                  {["\u25BA", "\u25BA|"].map((lbl, i) => (
                    <button key={lbl} type="button" onClick={() => navigateGratuity(i === 0 ? gratuityIndex + 1 : gratuityRecords.length - 1)} disabled={gratuityIndex === gratuityRecords.length - 1}
                      style={{ fontSize: 11, padding: "1px 6px", border: "1px solid #888", background: "#ddd", cursor: gratuityIndex === gratuityRecords.length - 1 ? "default" : "pointer", borderRadius: 2 }}>{lbl}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default AddEdit_PayrollParameter;
